import { Timezones } from "@swivl-mono/helpers";
import { CountryCodeMap, LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { DropdownRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.WhichMeasurementSystem,
  LocationVarKey.DefaultLanguage,
  LocationVarKey.HasLanguagePicker,
  { key: LocationVarKey.SecondaryLanguage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasLanguagePicker, "1") },
  { key: LocationVarKey.LanguagePickerMessage, hideIf: IS_NOT_EQUAL(LocationVarKey.HasLanguagePicker, "1") }
];

export default function LocationSubpageLocalization() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>Localization</h4>
      <WorksheetRow>
        <WorksheetColumn>
          {/* <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            label="Timezone"
            keyName={LocationVarKey.Timezone}
            options={Timezones.map((c) => ({
              label: c,
              value: c,
            }))}
          /> */}

          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            label="Measurement System"
            keyName={LocationVarKey.WhichMeasurementSystem}
            options={[
              {
                label: "Imperial",
                value: "Imperial"
              },
              {
                label: "Metric",
                value: "Metric"
              }
            ]}
          />

          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            label="Main Language"
            keyName={LocationVarKey.DefaultLanguage}
            options={[
              {
                label: "English",
                value: "English"
              },
              {
                label: "Spanish",
                value: "Spanish"
              },
              {
                label: "French",
                value: "French"
              }
            ]}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Ask for preferred language"
            keyName={LocationVarKey.HasLanguagePicker}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasLanguagePicker, "1")}
            label="Secondary Language"
            keyName={LocationVarKey.SecondaryLanguage}
            options={[
              {
                label: "English",
                value: "English"
              },
              {
                label: "Spanish",
                value: "Spanish"
              },
              {
                label: "French",
                value: "French"
              }
            ]}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasLanguagePicker, "1")}
            label="Language Picker Message"
            keyName={LocationVarKey.LanguagePickerMessage}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
